import Breadcrumb, { type Crumb } from "@/components/base/Breadcrumb";

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  crumbs: Crumb[];
}

export default function PageHeader({ eyebrow, title, desc, crumbs }: PageHeaderProps) {
  return (
    <section className="w-full bg-background-100 px-4 pb-12 pt-8 md:px-6 md:pb-16 md:pt-10">
      <div className="mx-auto max-w-6xl">
        <Breadcrumb items={crumbs} />
        <div className="mt-6 max-w-3xl">
          {eyebrow ? (
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 font-label text-xs text-accent-900">
              <i className="ri-fire-line"></i>
              {eyebrow}
            </span>
          ) : null}
          <h1 className="mt-4 font-heading text-2xl leading-snug text-foreground-950 md:text-4xl">{title}</h1>
          {desc ? <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p> : null}
        </div>
      </div>
    </section>
  );
}